import React from "react";
import "../../App.css";
import Typewriter from "typewriter-effect";
import me from "../../assets/gimpedit.png";
import sample from "../../components/CodeBlock/sample";
import { Link } from "react-router-dom";
import Animate from "../../components/Animate/Animate";
import { IoIosArrowDown } from "react-icons/io";
import { IconContext } from "react-icons";
import {
  AiFillGithub,
  AiFillLinkedin,
  AiFillTwitterCircle,
} from "react-icons/ai";
import { DiStackoverflow } from "react-icons/di";
import { MdEmail } from "react-icons/md";

function About() {
  function sendMail() {
    var aTag = document.createElement("a");
    aTag.href = "mailto: eda.twinkle@gmail.com";
    aTag.target = "_blank";
    aTag.id = "openMailClient";
    aTag.click();
  }

  return (
    <div className='App'>
      <header className='App-header'>
        <div className='sign'>
          <span className='fast-flicker'>A</span>ndrew-R
          <span className='flicker'>o</span>y
        </div>
        <Animate className='App-body'>
          <div className='demoApp'>
            <div style={{ display: "flex", position: "relative" }}>
              <img
                src={me}
                alt='me'
                style={{
                  width: "13rem",
                  height: "13rem",
                }}
              />
              <div
                style={{
                  backgroundImage:
                    "linear-gradient(to bottom, rgba(0,0,0,0.0), #323437)",
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                }}
              />
            </div>
            <p style={{ color: "#cacaca", fontSize: "19px" }}>
              {sample["description"]}
            </p>
            <Typewriter
              // options={{ loop: true }}
              onInit={(typewriter) => {
                typewriter
                  .typeString("connect with social media")
                  // .pauseFor(500)
                  // .deleteAll()
                  // .typeString("social media icons")
                  // .pauseFor(500)
                  // .deleteAll()
                  // .typeString("to send me a messege")
                  // .pauseFor(500)
                  // .deleteAll()
                  // .typeString("or email me, Thank you.")
                  // .pauseFor(500)
                  // .deleteAll()
                  .start();
              }}
            />
            <div
              style={{
                borderTop: "1px solid #44474d",
                width: "50%",
                padding: "0.02rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <IconContext.Provider
                value={{
                  color: "#7a7a7a",
                  size: "1.7rem",
                  style: { padding: "5px", cursor: "pointer" },
                }}>
                <AiFillGithub
                  onClick={() =>
                    window.open("https://github.com/AndrewRoy3535")
                  }
                />
                <AiFillTwitterCircle
                  onClick={() => window.open("https://twitter.com/AndrewEda")}
                />
                <DiStackoverflow
                  onClick={() =>
                    window.open(
                      "https://stackoverflow.com/users/14624383/andrew3535"
                    )
                  }
                />
                <AiFillLinkedin
                  onClick={() =>
                    window.open(
                      "https://www.linkedin.com/in/andrew-roy-twinkle/"
                    )
                  }
                />

                <MdEmail onClick={() => sendMail()} />
                {/* <AiFillFacebook
                  onClick={() =>
                    window.open("https://www.facebook.com/andrewroy3535/")
                  }
                /> */}
              </IconContext.Provider>
            </div>
          </div>
        </Animate>
      </header>
      <div
        style={{
          position: "absolute",
          right: "2%",
          top: "50%",
        }}
        className='navigator-about'>
        <Link to='/contact' className='moveArrowLeft'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div className='hover-text-div'>
              <p className='hover-text'>Contact</p>
              <IoIosArrowDown
                style={{
                  transform: "rotate(-90deg)",
                }}
              />
            </div>
          </IconContext.Provider>
        </Link>
      </div>
      <div
        style={{
          position: "absolute",
          left: "2%",
          top: "50%",
        }}
        className='navigator-about'>
        <Link to='/portfolio' className='moveArrowRight'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div className='hover-text-div'>
              <IoIosArrowDown style={{ transform: "rotate(90deg)" }} />
              <p className='hover-text'>Portfolio</p>
            </div>
          </IconContext.Provider>
        </Link>
      </div>
      {/* <div
        style={{
          position: "absolute",
          top: "85%",
          left: "50%",
        }}
        className='navigator-about'>
        <Link to='/skills' className='moveArrowDown'>
          <IconContext.Provider
            value={{
              color: "#7a7a7a",
              size: "3rem",
            }}>
            <div>
              <p className='hover-text' style={{ transform: "rotate(0deg)" }}>
                Skills
              </p>
              <IoIosArrowDown style={{ transform: "rotate(0deg)" }} />
            </div>
          </IconContext.Provider>
        </Link>
      </div> */}
    </div>
  );
}

export default About;
